export const phoneRegex = [
  new RegExp(/^(01[0|1|6|7|8|9])-([0-9]{3,4})-([0-9]{4})$/),
  new RegExp(/^(01[0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/),
  new RegExp(/^(\+821[0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/),
  new RegExp(/^(02)-([0-9]{3})-([0-9]{4})$/),
  new RegExp(/^(0[1-9]{2})-([0-9]{3})-([0-9]{4})$/),
  new RegExp(/^(02)([0-9]{3})([0-9]{4})$/),
  new RegExp(/^(0[1-9]{2})([0-9]{3})([0-9]{4})$/),
];

export const moneyRegex = new RegExp(/\B(?=(\d{3})+(?!\d))/g);

export const birthRegex = new RegExp(/^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/([1|2][0-9][0-9][0-9])$/);

export const restockPhoneRegex = new RegExp(/^\d+$/);
export const restockEmailRegex = new RegExp(/\S+@\S+/);

export const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);

export const numberRegex = new RegExp(/[^0-9]/g);
export const birthNumberRegex = new RegExp(/(^20[0-9][0-9]|^19[0-9][0-9]|^18[0-9][0-9]{4})([0-9]{2})([0-9]{2})$/);

export const instaRegex = new RegExp(/[^a-zA-Z0-9._]/g);

export const residentRegex = {
  CFP: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/, // 브라질 CPF: 000.000.000-00 형식
  CNPJ: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/, // 브라질 CNPJ: 00.000.000/0000-00 형식
  CN: /^\d{15}$|^\d{18}$|^[A-Z0-9]{10,12}$/, // 중국: 15자리, 18자리 주민번호 또는 10~12자리 EORI
  RFC: /^[A-ZÑ&]{3,4}\d{6}(?:[A-Z\d]{3})?$/i, // 멕시코
};
